module.exports = __webpack_public_path__ + "img/to.238ef1cd.svg";